<template>
  <UsageExample v-model="tab" :code="code" :tabs="tabs">
    <v-container class="d-flex flex-column ga-3">
      <v-row>
        <v-col>
          <v-card elevation="4" class="ma-4">
            <v-card-title class="font-weight-bold">Border</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <HxAccordion
                id="accordion-with-border"
                v-model:expanded="expandedAccordion"
                v-model:isSelected="isSelected"
                v-model:isToggled="isToggled"
                :title-text="!longTitle ? titleText : 'Panel title with a very long title'"
                :left-button="leftButton"
                :user-icon="userIcon"
                :right-button="rightButton"
                :title-icon="titleIcon"
                :helper-text="helperText"
                :show-checkbox="showCheckbox"
                :show-toggle-switch="showToggleSwitch"
                :chip-label="chipLabel"
                :chip-color="chipColor"
                :chip-icon="chipIcon"
                border
                @left-button-click="leftButtonClicked"
                @right-button-click="rightButtonClicked"
              >
                <template #content="{ enabled }">
                  <div class="my-2 d-flex justify-space-between align-center border-dashed rounded">
                    <span class="ma-2">insert component</span>
                    <HxToggleSwitch
                      v-model="settingSwitch"
                      right-label="On"
                      :disabled="!enabled"
                      class="ma-2"
                    />
                  </div>
                </template>
              </HxAccordion>
            </v-card-text>
          </v-card>
          <v-card elevation="4" class="ma-4">
            <v-card-title class="font-weight-bold">Elevated</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <HxAccordion
                id="accordion-with-elevated"
                v-model:expanded="expandedAccordion"
                v-model:isSelected="isSelected"
                v-model:isToggled="isToggled"
                :title-text="!longTitle ? titleText : 'Panel title with a very long title'"
                :left-button="leftButton"
                :user-icon="userIcon"
                :right-button="rightButton"
                :title-icon="titleIcon"
                :helper-text="helperText"
                :show-checkbox="showCheckbox"
                :show-toggle-switch="showToggleSwitch"
                :chip-label="chipLabel"
                :chip-color="chipColor"
                :chip-icon="chipIcon"
                elevated
                @left-button-click="leftButtonClicked"
                @right-button-click="rightButtonClicked"
              >
                <template #content="{ enabled }">
                  <div class="my-2 d-flex justify-space-between align-center border-dashed rounded">
                    <span class="ma-2">insert component</span>
                    <HxToggleSwitch
                      v-model="settingSwitch"
                      right-label="On"
                      :disabled="!enabled"
                      class="ma-2"
                    />
                  </div>
                </template>
              </HxAccordion>
            </v-card-text>
          </v-card>
          <v-card elevation="4" class="ma-4">
            <v-card-title class="font-weight-bold">Flat</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <HxAccordion
                id="accordion-with-flat"
                v-model:expanded="expandedAccordion"
                v-model:isSelected="isSelected"
                v-model:isToggled="isToggled"
                :title-text="!longTitle ? titleText : 'Panel title with a very long title'"
                :left-button="leftButton"
                :user-icon="userIcon"
                :right-button="rightButton"
                :title-icon="titleIcon"
                :helper-text="helperText"
                :show-checkbox="showCheckbox"
                :show-toggle-switch="showToggleSwitch"
                :chip-label="chipLabel"
                :chip-color="chipColor"
                :chip-icon="chipIcon"
                flat
                @left-button-click="leftButtonClicked"
                @right-button-click="rightButtonClicked"
              >
                <template #content="{ enabled }">
                  <div class="my-2 d-flex justify-space-between align-center border-dashed rounded">
                    <span class="ma-2">insert component</span>
                    <HxToggleSwitch
                      v-model="settingSwitch"
                      right-label="On"
                      :disabled="!enabled"
                      class="ma-2"
                    />
                  </div>
                </template>
              </HxAccordion>
            </v-card-text>
          </v-card>
          <v-card elevation="4" class="ma-4">
            <v-card-title class="font-weight-bold">Compact</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <HxAccordion
                id="accordion-with-compact"
                v-model:expanded="expandedAccordion"
                v-model:isSelected="isSelected"
                v-model:isToggled="isToggled"
                :title-text="!longTitle ? titleText : 'Panel title with a very long title'"
                :left-button="leftButton"
                :user-icon="userIcon"
                :right-button="rightButton"
                :title-icon="titleIcon"
                :helper-text="helperText"
                :show-checkbox="showCheckbox"
                :show-toggle-switch="showToggleSwitch"
                :chip-label="chipLabel"
                :chip-color="chipColor"
                :chip-icon="chipIcon"
                compact
                @left-button-click="leftButtonClicked"
                @right-button-click="rightButtonClicked"
              >
                <template #content="{ enabled }">
                  <div class="my-2 d-flex justify-space-between align-center border-dashed rounded">
                    <span class="ma-2">insert component</span>
                    <HxToggleSwitch
                      v-model="settingSwitch"
                      right-label="On"
                      :disabled="!enabled"
                      class="ma-2"
                    />
                  </div>
                </template>
              </HxAccordion>
            </v-card-text>
          </v-card>
          <v-card elevation="4" class="ma-4">
            <v-card-title class="font-weight-bold">Ultra Compact - Default</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <HxAccordion
                id="accordion-with-ultra-compact-default"
                v-model:expanded="expandedAccordion"
                v-model:isSelected="isSelected"
                v-model:isToggled="isToggled"
                :title-text="!longTitle ? titleText : 'Panel title with a very long title'"
                :left-button="leftButton"
                :user-icon="userIcon"
                :right-button="rightButton"
                :title-icon="titleIcon"
                :helper-text="helperText"
                :show-checkbox="showCheckbox"
                :show-toggle-switch="showToggleSwitch"
                :chip-label="chipLabel"
                :chip-color="chipColor"
                ultra-compact
                @left-button-click="filterButtonClicked"
                @right-button-click="rightButtonClicked"
                @chip-dismiss="dismissChip"
              >
                <template #content="{ enabled }">
                  <div class="d-flex justify-space-between align-center border-dashed rounded">
                    <span class="ma-2">insert component</span>
                    <HxToggleSwitch
                      v-model="settingSwitch"
                      right-label="On"
                      :disabled="!enabled"
                      class="ma-2"
                    />
                  </div>
                </template>
              </HxAccordion>
            </v-card-text>
          </v-card>
          <v-card elevation="4" class="ma-4">
            <v-card-title class="font-weight-bold">Ultra Compact - Custom</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <HxAccordion
                id="accordion-with-ultra-compact-custom"
                v-model:expanded="expandedAccordion"
                :title-text="!longTitle ? 'Filters' : 'Filters title with a very long title'"
                left-button="mdi-filter-outline"
                :chip-label="showChip ? '2 filters applied' : undefined"
                :chip-color="showChip ? 'grey' : undefined"
                :chip-dismissable="true"
                ultra-compact
                @left-button-click="filterButtonClicked"
                @chip-dismiss="dismissChip"
              >
                <template #content="{ enabled }">
                  <div class="d-flex justify-space-between align-center border-dashed rounded">
                    <span class="ma-2">insert component</span>
                    <HxToggleSwitch
                      v-model="settingSwitch"
                      right-label="On"
                      :disabled="!enabled"
                      class="ma-2"
                    />
                  </div>
                </template>
              </HxAccordion>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <template #configuration>
      <div class="d-flex flex-column mt-16">
        <hx-checkbox v-model="longTitle" :label="`Long title: ${longTitle}`" />
      </div>
    </template>
  </UsageExample>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixAccordion',
  components: { UsageExample },
  setup() {
    const code = `
<HxAccordion
  id="accordion-with-border"
  v-model:expanded="expandedAccordion"
  v-model:isSelected="isSelected"
  v-model:isToggled="isToggled"
  :title-text="titleText"
  :left-button="leftButton"
  :user-icon="userIcon"
  :right-button="rightButton"
  :title-icon="titleIcon"
  :helper-text="helperText"
  :show-checkbox="showCheckbox"
  :show-toggle-switch="showToggleSwitch"
  :chip-label="chipLabel"
  :chip-color="chipColor"
  :chip-icon="chipIcon"
  :chip-dismissable="true"
  border
  @left-button-click="leftButtonClicked"
  @right-button-click="rightButtonClicked"
  @chip-dismiss="dismissChip"
>
<template #content="{ enabled }">
<div class="my-2 d-flex justify-space-between align-center border-dashed rounded">
<span class="ma-2">insert component</span>
<HxToggleSwitch
v-model="settingSwitch"
right-label="On"
:disabled="!enabled"
class="ma-2"
/>
</div>
</template>
</HxAccordion>
        `;
    return { code };
  },
  data() {
    return {
      tab: 'Accordion Usage',
      tabs: ['Accordion Usage'],
      titleText: 'Panel title',
      leftButton: 'mdi-plus-circle-outline',
      userIcon: 'mdi-account-outline',
      rightButton: 'mdi-plus-circle-outline',
      titleIcon: 'mdi-account-outline',
      helperText: '(0/5)',
      showCheckbox: true,
      showToggleSwitch: true,
      isToggled: true,
      chipLabel: 'All',
      chipColor: 'pink',
      chipIcon: 'mdi-triangle',
      isSelected: false,
      expandedAccordion: undefined,
      longTitle: false,
      showHelperText: false,
      settingSwitch: false,
      showChip: true
    };
  },
  methods: {
    leftButtonClicked() {
      console.log('Left button clicked');
    },
    rightButtonClicked() {
      console.log('Right button clicked');
    },
    toggleLongTitle() {
      this.longTitle = !this.longTitle;
    },
    dismissChip() {
      this.showChip = false;
    },
    filterButtonClicked() {
      this.showChip = true;
    }
  }
};
</script>
